import { LocalisationStation } from "../Shared/localisation-station";
import { IBMRMesureStation } from "./IBMR-mesure-station";
import { IBMRUniteReleve } from "./IBMR-unite-releve";
import { Transect } from "./transect";

export class IBMRProcess {
    Code: string;
    HasUR2: boolean = false;
    LocalisationStation: LocalisationStation = new LocalisationStation();
    IBMRUniteReleve1: IBMRUniteReleve = new IBMRUniteReleve();
    IBMRUniteReleve2: IBMRUniteReleve = new IBMRUniteReleve();
    IBMRMesureStation: IBMRMesureStation = new IBMRMesureStation();

    static mapFromJSON(json): IBMRProcess {
        const p = new IBMRProcess();

        p.Code = json.code;
        p.HasUR2 = json.hasUR2;
        if (json.localisationStation)
            p.LocalisationStation = LocalisationStation.mapFromJSON(json.localisationStation);
        if (json.ibmrMesureStation)
            p.IBMRMesureStation = IBMRMesureStation.mapFromJSON(json.ibmrMesureStation);
        if (json.ibmrUniteReleve1)
            p.IBMRUniteReleve1 = IBMRUniteReleve.mapFromJSON(json.ibmrUniteReleve1);
        if (json.ibmrUniteReleve2)
            p.IBMRUniteReleve2 = IBMRUniteReleve.mapFromJSON(json.ibmrUniteReleve2);

        return p;
    }
}